import { ACTIVE_BOXER } from '@/utils/store/getterTypes'
import { getImagePaths } from '@/utils/general'
import { getMembershipTypeUrl } from '@/utils/prospect'
import { MembershipTypes } from '@/enums/member'

export default {
  [ACTIVE_BOXER] ({ form }) {
    const slug = form.design.slug || 'boxer'
    const name = form.design.name || 'Boxer'
    const membershipType = form.freeMembershipType || form.membershipType || MembershipTypes.menOriginals
    const membershipTypeUrl = getMembershipTypeUrl(membershipType)

    return {
      slug,
      name,
      images: getImagePaths({ s3: true, path: `/images/design/${slug}/products/${slug}-${membershipTypeUrl}-boxershort`, noMobile: true }),
      designPosterImages: getImagePaths({ s3: true, path: `/images/design/${slug}/signup/${slug}-${membershipTypeUrl}-extra`, noMobile: true })
    }
  }
}
